import { GridSize } from "@mui/material/Grid";

import { PatientReviewDetail } from "features/patients/sections/components";
import { WordList } from "services/types/word-lists.type";

type PreviewWordListProps = {
  data?: WordList;
  size?: boolean | GridSize;
};

export default function PreviewWordList({ data, size }: PreviewWordListProps) {
  return (
    <PatientReviewDetail
      title="Word List"
      value={data ? data?.content : "--"}
      size={size}
      lg={3}
    />
  );
}
